import { z } from 'zod';

export const CountrySchema = z.object({
  idCountry: z.number().int(),
  Country: z.string(),
});

export type ICountry = z.infer<typeof CountrySchema>;
